import {
  Avatar,
  Backdrop,
  Box,
  Button,
  Slide,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { fetchGet } from '../../../api/common';
import { Achievement, Mode } from '../types';
import './styles.css';
import { useSnackbar } from 'notistack';
import { AchievementAnimation } from './AchievementAnimation';
import { DetailedUserAchievement } from '@par/shared/types/player';

// GET THIS FROM THE DB!
const ARCANA_ACHIEVEMENTS = [
  'DRIVE_LIKE_JOHN_DAILY',
  'ALL_GREEN_FRIENDLY',
  'TRIPLE_CROWN',
  '24K',
  'DIAMONDS_ARE_FOREVER',
  'METRONOME',
  'MAVERICK',
  'ALL_GREEN_RANKED',
  'LOOK_AT_ME_IM_THE_TRIVIA_P,RO_NOW',
  'GRANDMASTER_RANK',
  'PANTHEON_RANK',
  'LONELY_AT_THE_TOP',
  'DEITY_AMONG_MORTALS',
  'BANSHEE',
  'WRAITH',
  'HAIL_MARY',
  'THE_PINK_RANGER_RISES',
  'MR_CLEANLINESS',
  'SCRATCH_PLAYER',
  'GRIPPED_AND_RIPPED',
  'THE_BLEEDING_EDGE',
  'THE_SCHOLAR',
  'THE_ROCKET_SURGEON',
  'THE_CONNOISSEUR',
  'TIGER_IN_THE_WOODS',
  'VIRTUOSO',
  'FUN_FOR_DAYS',
  'FRIENDLY_FIRE',
  'COMPETITIVE_JUICES',
];

type PropTypes = {
  achievements: string[];
  detailedUserAchievements: DetailedUserAchievement[];
  mode: Mode;
};

export const Achievements = ({
  achievements,
  detailedUserAchievements,
  mode,
}: PropTypes) => {
  const [show, setShow] = useState(false);
  const [detailedAchievements, setDetailedAchievements] = useState<
    Achievement[]
  >([]);
  const [newAchievements, setNewAchievements] = useState<Achievement[]>([]);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const fetchAchievement = async (achievements: string[]) => {
      const allAchievements: Achievement[] = [];
      for (const achievment of achievements) {
        const achievement = await fetchGet(
          `/achievements/achievement/${achievment}`
        );
        allAchievements.push(achievement);
      }
      setDetailedAchievements(allAchievements);
    };
    fetchAchievement(achievements);
  }, []);

  useEffect(() => {
    const newAchievements = [];
    for (const achievement of detailedAchievements) {
      if (hasAchievement(detailedUserAchievements, achievement.name)) {
        enqueueSnackbar(`Achievement earned: ${achievement.displayName}`, {
          anchorOrigin: {
            horizontal: 'right',
            vertical: 'bottom',
          },
        });
      } else {
        newAchievements.push(achievement);
      }
    }
    setNewAchievements(newAchievements);
    if (newAchievements.length) {
      setShow(true);
    }
  }, [detailedAchievements]);

  const theme = useTheme();

  const hasAchievement = (
    detailedUserAchievements: DetailedUserAchievement[],
    achievementName: string
  ) => {
    const foundAchievement = detailedUserAchievements.find(
      (ach) => ach.achievement.name === achievementName
    );
    if (
      foundAchievement &&
      !ARCANA_ACHIEVEMENTS.find((a) => a === foundAchievement.achievement.name)
    )
      return true;
    return false;
  };

  const handleDismiss = () => setShow(false);

  return (
    <>
      {detailedAchievements.length > 0 ? (
        <AchievementAnimation
          detailedAchievements={newAchievements}
          show={show}
        />
      ) : null}
    </>
  );
};
